import { render, staticRenderFns } from "./PhaseTypeReviewEdit.vue?vue&type=template&id=57473342&scoped=true"
import script from "./PhaseTypeReviewEdit.vue?vue&type=script&lang=js"
export * from "./PhaseTypeReviewEdit.vue?vue&type=script&lang=js"
import style0 from "./PhaseTypeReviewEdit.vue?vue&type=style&index=0&id=57473342&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57473342",
  null
  
)

export default component.exports